import {Column} from "../../components/BasicDataGrid";
import {IVirtualizedTableColumn, IVisibleTableColumnList} from "../../components/Table/VirtualizedTableInterfaces";

import ColumnFactory from "../../services/ColumnFactory";
import {OptionBasicDtoOptionType} from "../../services/Client";

import i18n from "i18next";

/** Column keys for all columns to be displayed for option basic. */
export const CategoryKey = "category";
export const CategoryTextKey = "categoryText";
export const OptionTypeColumnKey = "optionType";
export const OptionCodeColumnKey = "optionCode";
export const OptionReferenceColumnKey = "references";
export const PartNumberColumnKey = "partNumber";
export const CommentColumnKey = "comment";
export const StatusColumnKey = "statusView";
export const ShorttextKey = "shorttext";
export const LongtextKey = "longtext";
export const IntSequenceKey = "intSequence";
export const PDiPMFamilieKey = "pdipMFamilie";
export const PDiPMFamilieBezKey = "pdipMFamilieBez";
export const ChangedByKey = "changedBy";
export const ChangedTimestampKey = "changedTimestamp";
export const PdipTextKey ='pdiptext';

/**
 * All possible columns supported for option basic.
 * The order is relevant for the column table position
 */
export const OptionBasicColumnKeys = [
    CategoryTextKey,
    OptionCodeColumnKey,
    IntSequenceKey,
    PdipTextKey,
    ShorttextKey,
    LongtextKey,
    StatusColumnKey,
    CommentColumnKey,
    OptionReferenceColumnKey,
    OptionTypeColumnKey,
    PartNumberColumnKey,
    PDiPMFamilieKey,
    PDiPMFamilieBezKey,
    ChangedByKey,
    ChangedTimestampKey
];

/** Mapping of column key -> column params to be passed down to ColumnFactory. */
export type ColumnParams = {[key: string]: object};

/** Column param object assigned to this key is used with every column. */
export const ColumnParamAllKey: string = "ALL_COLUMNS_KEY";

/** Create corresponding column for the given key. */
export const createColumn = (columnKey: string, params?: ColumnParams): Column => {
    const combinedParams = Object.assign(
        {},
        params && params[ColumnParamAllKey], // params valid for every column
        params && params[columnKey],
    );

    switch (columnKey) {
        case OptionTypeColumnKey:
            Object.assign(combinedParams, {
                dataSource: Object.keys(OptionBasicDtoOptionType),
                rendererKey: (dto: OptionBasicDtoOptionType) => i18n.t("GLOBAL:" + dto) + " (" + dto + ')' ,
            });
            break;
        default:
            break;
    }
    return ColumnFactory.getColumnWithParameters(columnKey, combinedParams);
};

export function sortOBColumns(a: IVirtualizedTableColumn, b: IVirtualizedTableColumn): number {
    return OptionBasicColumnKeys.indexOf(a.key) - OptionBasicColumnKeys.indexOf(b.key);
}

export function sortOBColumnsDropdown(list: IVisibleTableColumnList): IVisibleTableColumnList {
    let columns: IVisibleTableColumnList = {};
    let sortedKeys = Object.keys(list);
    sortedKeys.sort((a, b) => {
        return OptionBasicColumnKeys.indexOf(a) - OptionBasicColumnKeys.indexOf(b);
    });

    sortedKeys.forEach((key) => {
        columns[key] = list[key];
    });

    return columns;
}



// WEBPACK FOOTER //
// ./src/views/BaseOptionsView/BaseOptionsColumns.ts